import { lazy } from 'react';

const RELOAD_FLAG = 'bf_chunk_reload';

// React.lazy that survives a deploy: when a stale tab requests a chunk hash that no
// longer exists, reload once to pick up the new index.html instead of showing a crash.
export function lazyRetry(importer) {
  return lazy(() =>
    importer()
      .then((mod) => {
        sessionStorage.removeItem(RELOAD_FLAG);
        return mod;
      })
      .catch((err) => {
        const alreadyReloaded = sessionStorage.getItem(RELOAD_FLAG) === '1';
        if (!alreadyReloaded && typeof window !== 'undefined') {
          sessionStorage.setItem(RELOAD_FLAG, '1');
          window.location.reload();
          return new Promise(() => {});
        }
        throw err;
      })
  );
}
